import {TEXT} from '@drivesally/sally-fw/lib/inputTypes';

// attribute
import attribute from '@drivesally/sally-fw/lib/attribute/attribute';

export default attribute({
  type: TEXT,
  attribute: 'insurance_company_name',
  label: {
    default: 'Insurance Company Name',
    short: 'Insurance Company Name',
  },
});
